import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";

import User from "@/Models/User";

import api from "../Api";

import { useAuthStore } from "../hooks";

export const CONSTANTS = {
  FETCH_USER: "FETCH_USER",
};

const INITIAL_STATE = {
  user: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case CONSTANTS.FETCH_USER:
      return {
        ...state,
        user: action.user,
      };
    default:
      return INITIAL_STATE;
  }
};

export const Context = createContext(INITIAL_STATE);

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ dispatch, state }}>{children}</Context.Provider>
  );
};

export const useProfileStore = () => {
  const { dispatch, state } = useContext(Context);
  const { signOut } = useAuthStore();

  const fetchUser = useCallback(async () => {
    const user = await api.get("/me");

    if (!!user.locked) {
      window.alert(
        "이용정지 상태입니다. 두발히어로 운영팀 단톡방으로 연락 부탁드립니다.",
      );
      signOut();
      return;
    }

    dispatch({
      type: CONSTANTS.FETCH_USER,
      user: new User(user),
    });

    return new User(user);
  }, [dispatch]);

  const update = useCallback(
    async ({ autoPrint, contact, realname }) =>
      await api.put(`/me`, { autoPrint, contact, realname }),
    [],
  );

  const updatePassword = useCallback(
    async (data) => await api.put(`/me/password`, data),
    [],
  );

  const updateSenderNames = useCallback(
    async (data) => await api.put(`/me/sender-names`, data),
    [],
  );

  return {
    state,
    fetchUser,
    update,
    updatePassword,
    updateSenderNames,
  };
};
